// extracted by mini-css-extract-plugin
export default {"squareRatio":"GHOmV7","content":"vHguON","wideRatio":"lz6rSP"};